/*
 * Copyright (c) 2024 Amazon.com, Inc. All Rights Reserved.
 */

export enum Stage {
  Prod = "Prod",
  Gamma = "Gamma"
}

export interface StageConfig {
  stage: Stage;
  url: string;
}